import React from 'react';
import Tooltip from './tooltip';
import {
  DiAndroid,
  DiAngularSimple,
  DiBootstrap,
  DiChrome,
  DiCss3,
  DiHtml5,
  DiIllustrator,
  DiJava,
  DiJsBadge,
  DiMongodb,
  DiMysql,
  DiNodejs,
  DiPhotoshop,
  DiPython,
  DiSass,
  DiUnitySmall,
} from 'react-icons/di';
import {
  SiAmazonaws,
  SiCplusplus,
  SiCsharp,
  SiElectron,
  SiGatsby,
  SiKeras,
  SiPowershell,
  SiSketch,
  SiTypescript,
  SiTailwindcss,
} from 'react-icons/si';
import { ImFileText2 } from 'react-icons/im';
import { FaRegImages } from 'react-icons/fa';
import { GiGamepad } from 'react-icons/gi';

export default function IconUtil(props) {
  const renderSwitcha = (param) => {
    switch (param) {
      case 'Python':  return <Tooltip title="Python"  > <DiPython className={props.className} /></Tooltip>
      case 'RL':  return <Tooltip title="Reinforcement Learning" > <GiGamepad  className={props.className} /></Tooltip>
      case 'CV':  return <Tooltip title="Computer vision" > <FaRegImages className={props.className} /></Tooltip>
      case 'Unity': return <Tooltip title="Unity"  > <DiUnitySmall className={props.className} /></Tooltip>
      case 'C#':  return <Tooltip title="C"  > <SiCsharp className={props.className} /></Tooltip>
      case 'Android': return <Tooltip title="Android"  > <DiAndroid className={props.className} /></Tooltip>
      case 'NodeJS':  return <Tooltip title="NodeJS"  > <DiNodejs className={props.className} /></Tooltip>
      case 'Shell': return <Tooltip title="Shell"  > <SiPowershell className={props.className} /></Tooltip>
      case 'C++': return <Tooltip title="C"  > <SiCplusplus className={props.className} /></Tooltip>
      case 'HTML':  return <Tooltip title="HTML"  > <DiHtml5 className={props.className} /></Tooltip>
      case 'CSS': return <Tooltip title="CSS"  > <DiCss3 className={props.className} /></Tooltip>
      case 'JS':  return <Tooltip title="JavaScript"  > <DiJsBadge className={props.className} /></Tooltip>
      case 'Chrome':  return <Tooltip title="Chrome"  > <DiChrome className={props.className} /></Tooltip>
      case 'PhotoShop': return <Tooltip title="PhotoShop"  > <DiPhotoshop className={props.className} /></Tooltip>
      case 'Illustrator': return <Tooltip title="Illustrator" > <DiIllustrator className={props.className} /></Tooltip>
      case 'Sketch':  return <Tooltip title="Sketch"  > <SiSketch className={props.className} /></Tooltip>
      case 'Keras': return <Tooltip title="Keras"  > <SiKeras className={props.className} /></Tooltip>
      case 'NLP': return <Tooltip Natural Language Processing > <ImFileText2 className={props.className} /></Tooltip>
      case 'Angular': return <Tooltip title="Angular" > <DiAngularSimple className={props.className} /></Tooltip>
      case 'MongoDB': return <Tooltip title="MongoDB"  > <DiMongodb className={props.className} /></Tooltip>
      case 'SCSS':  return <Tooltip title="SCSS"  > <DiSass className={props.className} /></Tooltip>
      case 'AWS': return <Tooltip title="AWS"  > <SiAmazonaws className={props.className} /></Tooltip>
      case 'Electron':  return <Tooltip title="Electron"  > <SiElectron className={props.className} /></Tooltip>
      case 'TS':  return <Tooltip title="TypeScript" > <SiTypescript className={props.className} /></Tooltip>
      case 'SQL': return <Tooltip title="SQL"  > <DiMysql className={props.className} /></Tooltip>
      case 'BootStrap': return <Tooltip title="BootStrap"  > <DiBootstrap className={props.className} /></Tooltip>
      case 'Java': return <Tooltip title="Java"  > <DiJava className={props.className} /></Tooltip>
      case 'Gatsby': return <Tooltip title="Gatsby"  > <SiGatsby className={props.className} /></Tooltip>
      case 'Tailwind': return <Tooltip title="Tailwind CSS"  ><SiTailwindcss className={props.className} /></Tooltip>
      default:
        return <SiCplusplus className={props.className} />;
    }
    return null;
  };
  return renderSwitcha(props['icon']);
}
